import { Component, inject, Input, type OnInit } from '@angular/core';
import { type RolodexCompanyNoteDTO } from '@api/models';
import { RolodexCompanyNoteService } from '@api/services/rolodex-company-note.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-rolodex-note-view-dialog',
  templateUrl: './rolodex-note-view-dialog.component.html',
  imports: [TranslatePipe],
})
export class RolodexNoteViewDialogComponent implements OnInit {
  private readonly rolodexCompanyNoteService = inject(RolodexCompanyNoteService);

  @Input() modal: NgbActiveModal;
  @Input() rolodexCompanyId: string;

  rolodexNote: RolodexCompanyNoteDTO;

  ngOnInit(): void {
    this.rolodexCompanyNoteService.list(this.rolodexCompanyId).subscribe(response => {
      if (response && response.length > 0) {
        this.rolodexNote = response[0];
      }
    });
  }
}
